import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import AcademicScoreManagementPage from './pages/AcademicScoreManagementPage';
import AssessmentScoreQueryPage from './pages/AssessmentScoreQueryPage';
import BaselineRosterPage from './pages/BaselineRosterPage';
import BatchManagementPage from './pages/BatchManagementPage';
import BonusAuditPage from './pages/BonusAuditPage';
import ComprehensiveAssessmentSummaryPage from './pages/ComprehensiveAssessmentSummaryPage';
import ComprehensiveQualityScoringPage from './pages/ComprehensiveQualityScoringPage';
import CounselorScoringPage from './pages/CounselorScoringPage';
import GenericPage from './pages/GenericPage';
import IndicatorManagementPage from './pages/IndicatorManagementPage';
import MaliciousScoringPage from './pages/MaliciousScoringPage';
import MyBonusPage from './pages/MyBonusPage';
import PanelManagementPage from './pages/PanelManagementPage';
import PeerReviewTasksPage from './pages/PeerReviewTasksPage';
import ScoringParameterConfigPage from './pages/ScoringParameterConfigPage';
import StudentPeerReviewPage from './pages/StudentPeerReviewPage';
import TemplatePage from './pages/TemplatePage';
import TemplateTabbedPage from './pages/TemplateTabbedPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/my-peer-review" replace />} />
        <Route path="batch-management" element={<BatchManagementPage />} />
        <Route path="indicator-management" element={<IndicatorManagementPage />} />
        <Route path="scoring-parameter-config" element={<ScoringParameterConfigPage />} />
        <Route path="baseline-roster" element={<BaselineRosterPage />} />
        <Route path="panel-management" element={<PanelManagementPage />} />
        <Route path="peer-review-tasks" element={<PeerReviewTasksPage />} />
        <Route path="malicious-scoring" element={<MaliciousScoringPage />} />
        <Route path="academic-score-management" element={<AcademicScoreManagementPage />} />
        <Route path="bonus-audit" element={<BonusAuditPage />} />
        <Route path="counselor-scoring" element={<CounselorScoringPage />} />
        <Route path="quality-scoring" element={<ComprehensiveQualityScoringPage />} />
        <Route path="student-bonus" element={<GenericPage title="学生加分管理" />} />
        <Route path="assessment-summary" element={<ComprehensiveAssessmentSummaryPage />} />
        <Route path="assessment-query" element={<AssessmentScoreQueryPage />} />
        <Route path="my-bonus" element={<MyBonusPage />} />
        <Route path="my-assessment-score" element={<GenericPage title="我的综合测评成绩" />} />
        <Route path="my-peer-review" element={<StudentPeerReviewPage />} />
        <Route path="template-page" element={<TemplatePage />} />
        <Route path="template-tabbed-page" element={<TemplateTabbedPage />} />
        <Route path="*" element={<Navigate to="/my-peer-review" replace />} />
      </Route>
    </Routes>
  );
}
